import React, { useEffect, useState, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

import { MenuComponent } from '../../../../_template/assets/ts/components/MenuComponent';
import { ToggleComponent } from '../../../../_template/assets/ts/components/ToggleComponent';

import Pagination from '../../../component/common/pagination/Pagination';
import NoDataFound from '../../../component/common/NoDataFound';
import BotList from './BotList';
import { PageTitle } from '../../../../_template/layout/core/PageData';
import DashboardInfoCard from '../../../component/DashboardInfoCard';
import DashboardInfoSkeleton from '../systemAdminReg/component/DashboardInfoSkeleton';
import DateRangePicker from '../../../component/common/DateRangePicker';
import { spDateRange, newTimezoneOffset } from '../../../component/common/Helper';

const Dashboard = () => {
    const api_base_url = process.env.REACT_APP_API_URL;

    const pageTitle = [
        {
            title: 'Dashboard',
            path: 'dashboard',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const [loading, setLoading] = useState(true);
    const [businessData, setBusinessData] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [dateState, setDateState] = useState({
        startDate: '',
        endDate: ''
    });
    const [searchData, setSearchData] = useState({
        dateRange: {},
        enterInput: ''
    });
    const [page, setPage] = useState(1)
    const [searchBtnLoader, setSearchBtnLoader] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
            ToggleComponent.reinitialization()
        }, 500);
    })


    const datepickerOnChangeHandler = (dates) => {
        if(dates){
            setDateState({
                startDate: dates[0],
                endDate: dates[1],
            });
            const dateRangeVal = spDateRange(dates)
            setSearchData(prev => ({
                ...prev,
                dateRange: {
                    startDate: dateRangeVal.startDate,
                    endDate: dateRangeVal.endDate,
                }
            }))
        }
        else{
            setDateState({
                startDate: '',
                endDate: '',
            });
            setSearchData(prev => ({
                ...prev,
                dateRange: {}
            }))
        }
    }

    useEffect(()=>{
        getAllBusiness();
    },[page])
    
    const getAllBusiness = async () => {
        setLoading(true);
        try {
            var api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('systemAdminToken'),
                    "timezone-offset" : newTimezoneOffset()
                }
            };

            const sendParam = {
                username: localStorage.getItem('system_username'),
                search_data: searchData,
                page: page,
                limit: 50
            }
            await axios.post(`${api_base_url}business/get-business-details`, sendParam, api_headers)
            .then(async (res) => {
                setLoading(false);
                setSearchBtnLoader(false)
                if(res.data.status === 'success') {
                    setBusinessData(res.data.data.businessData);
                    setPaginationData({
                        current_pages : res.data.data.current_pages,
                        total_data_count : res.data.data.total_count,
                        total_pages : res.data.data.total_pages,
                        limit : res.data.data.limit,
                        data_length : res.data.data.businessData.length
                    })
                } else if(res.data.status === 'error') {
                    console.error('error')
                }
            })
            .catch((error) => {
                console.error(error);
                setSearchBtnLoader(false)
                setLoading(false);
            })
        } catch (error) {
            console.error(error)
            setLoading(false);
            setSearchBtnLoader(false)
        }
    };

    const deleteHandel = () => {
        getAllBusiness();
    }

    let businessListHtml = '';
    if( businessData.length > 0 ){
        businessListHtml = businessData.map((item, index) => 
            <DashboardInfoCard 
                items={item} 
                key={index}
                onDelete={deleteHandel} 
            />
        )
    }

    useEffect(() => {
        document.body.setAttribute('data-sai-app-sidebar-hoverable', 'flase')
        document.body.setAttribute('data-sai-app-sidebar-push-header', 'false')
        document.body.setAttribute('data-sai-app-sidebar-push-toolbar', 'false')
        document.body.setAttribute('data-sai-app-sidebar-enabled', 'false')
        document.body.setAttribute('data-sai-app-sidebar-fixed', 'false')
        document.body.setAttribute('data-sai-app-toolbar-enabled', 'false')
    }, [])


    // ------- pagination ----- //
    const pagechangeHandler = (pageNumber, type) => {
        if( type === 'previous' ){
            setPage((c_page) => c_page - 1)
        }else if( type === 'page' ){
            setPage(pageNumber)
        }
        else if( type === 'next' ){
            setPage((c_page) => c_page + 1)
        }
    }

    const hasLogData = businessData.length > 0;
    const noBusinessData = !loading && !hasLogData;

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="card card-rounded border mb-6">
                    <div className="card-header">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">
                                Business List
                            </span>
                            <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                Total 
                                <span className='mx-1'>
                                    {paginationData.total_data_count ? paginationData.total_data_count : 0}
                                </span>
                                business are available
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <div className="d-flex flex-stack flex-wrap gap-0">
                                <div className="position-relative me-2 m-w-100 d-flex">
                                    <DateRangePicker
                                        value={[dateState.startDate, dateState.endDate]}
                                        onChange={datepickerOnChangeHandler}
                                        className='me-2'
                                    />
                                    <div className="input-group">
                                        <input 
                                            type="text"
                                            className="form-control w-350px"
                                            placeholder="Search by business name, id or access url"
                                            onChange={(e) => {
                                                setSearchData(prev => ({
                                                    ...prev,
                                                    enterInput: e.target.value
                                                }))
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex align-items-center fw-bold">
                                    <button 
                                        className="btn btn-warning px-6 btn-icon" 
                                        onClick={() => {{
                                            setSearchBtnLoader(true)
                                            getAllBusiness()
                                        }}}
                                        disabled={searchBtnLoader}
                                    >
                                        {
                                            searchBtnLoader ?
                                            <FontAwesomeIcon icon={faArrowsRotate} className='fs-3 fa-spin'/> 
                                            :
                                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                loading &&(
                    <DashboardInfoSkeleton rows={10}/>
                )
            }
            {
                noBusinessData && (
                    <NoDataFound
                        setHtml="No Data Found"
                        className="w-30"
                    />
                )
            }
            {
                hasLogData && (
                    <>
                        {businessListHtml}
                        <div className='col-md-12'>
                            <Pagination
                                pagination_data={paginationData}
                                onClick={pagechangeHandler}
                            />
                        </div>
                    </>
                )
            }
        </div>
    )
}
export default Dashboard